import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbDialogModule, NbDialogRef, NbLayoutDirection, NbLayoutModule, NbThemeModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { FeatureModule } from 'src/app/feature/feature.module';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FeatureModule,
    HttpClientModule,
    NbDialogModule.forRoot(),
    NbThemeModule.forRoot({ name: 'cosmic' }, undefined, undefined, NbLayoutDirection.RTL),
    NbLayoutModule,
    NbEvaIconsModule,
    RouterModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
